import { flow } from 'lodash';
import { takeLatest, put, select, delay, call } from 'redux-saga/effects';

import getApiClientsPartnersIdService from '@giro/shared-services/pdv/getApiClientsPartnersId.service';

import toaster from '@giro/shared-store/toaster';
import auth from '@giro/shared-store/auth';

import pinpad from '../pinpad';

import currentStore from '.';

function* handleServiceGet(action) {
  const user = yield select(auth.selector.selectUser);

  const showToaster = flow(toaster.action.show, put);
  yield put(currentStore.action.fetchStart());

  try {
    const [success, result] = yield call(
      getApiClientsPartnersIdService,
      user.user.codes.idClient
    );

    if (!success) {
      throw result;
    }

    yield put(currentStore.action.fetchSuccess(result));
  } catch (e) {
    yield showToaster({
      message: 'Aconteceu um erro, tente novamente mais tarde',
      variant: 'error',
    });
  }
}

function* watch() {
  yield takeLatest(
    currentStore.constant.ACTION_TYPES.SERVICE.GET,
    handleServiceGet
  );
}

export default {
  watch,
};
